(function () {
    'use strict';



    angular
        .module('searchV2Module')
        .config(['searchV2ServiceProvider', function (searchV2ServiceProvider) {

            searchV2ServiceProvider.setStateParamsConfig({
                sf: { // selected Fields
                    value: undefined,
                    array: true
                }
            });

            searchV2ServiceProvider.stateParamsToSourceQueryParamsTransformers.push(function (stateParams, searchSource, isSourceTypeSelected) {
                searchSource.queryParams.withFaceting = true;

                if (!isSourceTypeSelected) return;

                searchSource.queryParams.sf = _.chain(stateParams.sf)
                              .filter(function (sf) { // sf ->  itemTypeID;field:value
                                  var splitted = sf.split(';');
                                  if (splitted.length === 1) return true;

                                  var sfItemTypeID = parseInt(splitted[0], 10);
                                  return sfItemTypeID === searchSource.ItemTypeID;
                              })
                             .map(function (sf) {
                                 var splitted = sf.split(';');

                                 return _.last(splitted);
                             })
                             .value();
                searchSource.queryParams.fq = stateParams.fq;
            });

            searchV2ServiceProvider.searchResultToContextTransformers.push(function (searchCtxt, stateParams, isSourceTypeSelected) {

                if (!isSourceTypeSelected) return;

                searchCtxt.sources = _.map(searchCtxt.sources, function (sourceCtxt) {
                    if (_.isEmpty(sourceCtxt.searchResponse)) return sourceCtxt;
                    if (_.isUndefined(sourceCtxt.searchResponse.facet_counts)) return sourceCtxt;

                    sourceCtxt.faceting = sourceCtxt.searchResponse.facet_counts;

                	// list of selected values like 99;Month|OR|tag:04 and 99;Month|OR|tag:03
                	// will become an a property in an object like this:
                	// "Month": {
                	//		"04": true,
					//		"03": true
					// }
                    sourceCtxt.faceting.selectedFields = _.reduce(stateParams.sf, function (selectedFields, filterQuery) {
                        var splitted = filterQuery.split(';');
                        var itemTypeID = parseInt(splitted[0], 10);
                        if (itemTypeID !== sourceCtxt.ItemTypeID) return selectedFields;

                        var fieldValue = splitted[1].split(':');
                        var field = fieldValue[0];
	                    var value = fieldValue[1];

	                    if (!_.has(selectedFields, field)) {
		                    selectedFields[field] = {};
	                    }

                        selectedFields[field][value] = true;

                        return selectedFields;
                    }, {});

                    var selectedRanges = _.reduce(stateParams.fq, function (selectedRanges, filterQuery) {
                        var fieldRangeValue = filterQuery.split(':');
                        var field = fieldRangeValue[0];
                        var rangeValue = fieldRangeValue[1];

                        selectedRanges[field] = rangeValue;

                        return selectedRanges;
                    }, {});

                    _.assign(sourceCtxt.faceting.selectedFields, selectedRanges);

                    return sourceCtxt
                });
            });

        }])
        .directive('searchFacets', directive);

    directive.$inject = [];

    function directive() {
        return {
            restrict: 'AE',
            scope: {
                version: '=?',
                searchCtxt: '=',
                searchSource: '=',
                onFacetChanged: '&'
            },
            template: '<div ng-include="getTemplateUrl()"></div>',
            controller: ['$scope', 'searchV2Service', function ($scope, searchV2Service) {

                var controlStatusFacetGroups = {
                    PendingInformation: {
                        value: 'PendingInformation',
                        ControlStatusCssLabel: 'label label-gray',
                        ControlStatusCssIcon: 'fa fa-flag',
                        ColumnValue: 'Pending Information',
                    },
                    ReadyForTesting: {
                        value: 'ReadyForTesting',
                        ControlStatusCssLabel: 'label label-blue',
                        ControlStatusCssIcon: 'fa fa-pencil-square-o',
                        ColumnValue: 'Ready For Testing'
                    },
                    TestingInProgress: {
                        value: 'TestingInProgress',
                        ControlStatusCssLabel: 'label label-cyan',
                        ControlStatusCssIcon: 'fa fa-clock-o',
                        ColumnValue: 'Testing In Progress'
                    },
                    ControlTestingToReview: {
                        value: 'ControlTestingToReview',
                        ControlStatusCssLabel: 'label label-warning',
                        ControlStatusCssIcon: 'fa fa-clock-o',
                        ColumnValue: 'Control Testing To Review'
                    },
                    ReadyForCertification: {
                        value: 'ReadyForCertification',
                        ControlStatusCssLabel: 'label label-gold',
                        ControlStatusCssIcon: 'fa fa-certificate',
                        ColumnValue: 'Ready For Certification'
                    },
                    CertificationInProgress: {
                        value: 'CertificationInProgress',
                        ControlStatusCssLabel: 'label label-red',
                        ControlStatusCssIcon: 'fa fa-clock-o',
                        ColumnValue: 'Certification In Progress'
                    },
                    CertificationToReview: {
                        value: 'CertificationToReview',
                        ControlStatusCssLabel: 'label label-purple',
                        ControlStatusCssIcon: 'fa fa-clock-o',
                        ColumnValue: 'Certification To Review'
                    },
                    Completed: {
                        value: 'Completed',
                        ControlStatusCssLabel: 'label label-green',
                        ControlStatusCssIcon: 'fa fa-check-square-o',
                        ColumnValue: 'Completed'
                    }
                };

                $scope.isFacetOpened = false;

                $scope.initialMaxFacets = 5;


                $scope.getTemplateUrl = function () {
                    if (_.isUndefined($scope.version)) $scope.version = 'default';

                    return '/app/shared/searchV2/searchFacets-' + $scope.version + '.tpl.html';
                };

                $scope.toggleFacetOpened = function () {
                    $scope.isFacetOpened = !$scope.isFacetOpened;
                };

                $scope.showFacetsBox = function () {
                    if (_.isUndefined($scope.searchSource)) return false;
                    if (_.isUndefined($scope.searchSource.faceting)) return false;

                    var hasFacets = _.some($scope.searchSource.faceting, function (facetType) {
                        return _.size(facetType);
                    });

                    return hasFacets;
                };

                $scope.showClearFilters = function () {
                    if (_.isUndefined($scope.searchSource)) return false;
                    if (_.isUndefined($scope.searchSource.faceting)) return false;

                    return _.size($scope.searchSource.faceting.selectedFields) > 0;
                };

                $scope.clearFilters = function () {
                    searchV2Service
                        .search({
                            sf: [],
                            fq: []
                        }).then(function (searchCtxt) {
                            $scope.searchCtxt = searchCtxt;
                            if ($scope.onFacetChanged) $scope.onFacetChanged();
                        });
                };

                $scope.isFieldValueDisabled = function (fieldValue, fieldValueOp) {
                	return (_.isUndefined(fieldValueOp) || fieldValueOp === 'AND') && fieldValue.count === 0;
                };

                var convertToRangeValue = function (rangeStart, rangeEnd, rangeConfig) {
                    if (rangeConfig && rangeConfig.valueFormatter) {
                        rangeStart = rangeConfig.valueFormatter(rangeStart);
                        rangeEnd = rangeConfig.valueFormatter(rangeEnd);
                    }
                    var result = '[' + rangeStart + ' TO ' + rangeEnd + ']';

                    return result;
                };



                $scope.toggleFacetSelection = function (field, fieldValue, fieldValueOp) {

                	if ($scope.isFieldValueDisabled(fieldValue, fieldValueOp)) return;

	                if (fieldValue.value) {
		                fieldValue = fieldValue.value;
	                }

	                // list of selected values like 99;Month|OR|tag:04 and 99;Month|OR|tag:03
	                // will become an a property in an object like this:
	                // "Month": {
	                //		"04": true,
	                //		"03": true
                	// }
					// So the new selected values must retain the same format

	                if ((_.isUndefined(fieldValueOp) || _.isEmpty(fieldValueOp) || fieldValueOp === 'AND')
							&& _.has($scope.searchSource.faceting.selectedFields, field)) {
                        delete $scope.searchSource.faceting.selectedFields[field];
                	} else {
                		if (!_.has($scope.searchSource.faceting.selectedFields, field)) {
			                $scope.searchSource.faceting.selectedFields[field] = {};
                		}
		                var selectedField = $scope.searchSource.faceting.selectedFields[field];
		                selectedField[fieldValue] = _.isUndefined(selectedField[fieldValue]) || !selectedField[fieldValue];
                    }

                	var sfParams = _.reduce($scope.searchSource.faceting.selectedFields, function (sfArray, sValues, sField) {

                		_.reduce(sValues, function (sfArray, isChecked, sValue) {
                			if (!isChecked) {
				                return sfArray;
			                }

                			var sf = $scope.searchSource.ItemTypeID + ';' + sField + ':';

			                sf = sf + sValue;
			                sfArray.push(sf);

			                return sfArray;
		                }, sfArray);

		                return sfArray;
                    }, []);

                    var fqParams = _.reduce($scope.searchSource.faceting.selectedFields, function (srArray, sValue, sField) {
                        if (sValue.type === 'sr') {
                            var sr = /*$scope.searchSource.ItemTypeID + ';' +*/ sField + ':' + sValue.rangeValue;
                            srArray.push(sr);
                        }

                        return srArray;
                    }, []);

                    searchV2Service.search({
                        sf: sfParams,
                        fq: fqParams
                    }).then(function (searchCtxt) {
                        $scope.searchCtxt = searchCtxt;
                        if ($scope.onFacetChanged) $scope.onFacetChanged();
                    });
                };

                var rangesConfigs = {
                    "Hour": {
                        valueTransformer: function (value, nextValue) {
                            return _.template('<%= lower %>h - <%= upper %>h')({ lower: value, upper: nextValue });
                        },
                        beforeValueTransformer: function (value) {
                            return _.template('Before <%= lower %>h')({ lower: value });
                        },
                        afterValueTransformer: function (value) {
                            return _.template('After <%= upper %>h')({ upper: value });
                        }
                    },
                    "Month": {
                        valueFormatter: function (value) {
                            var dateStr = value.substring(0, value.indexOf("T"));

                            return dateStr;
                        },
                        valueTransformer: function (fieldValue) {
                            var date = moment(fieldValue.substring(0, fieldValue.indexOf("T")));
                            if (date.isSame(moment(), 'month')) return 'This Month';
                            if (date.isSame(moment().add(1, 'month'), 'month')) return 'Next Month';

                            return fieldValue;
                        }
                    },
                    "Day": {
                        valueFormatter: function (value) {
                            var dateStr = value.substring(0, value.indexOf("T"));

                            return dateStr;
                        },
                        valueTransformer: function (fieldValue) {
                            var date = moment(fieldValue.substring(0, fieldValue.indexOf("T")));
                            if (date.isSame(moment(), 'day')) return 'Today';
                            if (date.isSame(moment().add(1, 'day'), 'day')) return 'Tomorrow';
                            if (date.isSame(moment().add(-1, 'day'), 'day')) return 'Yesterday';

                            return fieldValue;
                        }
                    }
                };

                $scope.expandFacet = function (facetField) {
                    facetField.limit = 999;
                }

                $scope.collapseFacet = function (facetField) {
                    facetField.limit = $scope.initialMaxFacets;

                }


                $scope.mapFacets = function (facetsToMap, selectedFacets) {
                    var facets = {};

                    facets.facet_fields = _.reduce(facetsToMap.facet_fields, function (facetFields, fieldValues, field) {
                        if (fieldValues.length === 0) return facetFields;

                        var splittedField = field.split('->'); // ex: Control Area->ControlArea
                        var fieldAlias = splittedField[0];
                        var fieldName = fieldAlias;
                        if (splittedField.length > 1) fieldName = splittedField[1];

                        var fieldNameParts = fieldName.split('|'); // ex: ControlArea|OR|fieldTag
                        var fieldValueOp = 'AND';
	                    if (fieldNameParts.length > 1) {
	                    	fieldValueOp = fieldNameParts[1];
	                    }


                        var personFacet = false;
                        if (field === 'Head->Head_DisplayName_facet' ||
		                    field === 'Chairs->Chairs_DisplayNames_facet' ||
		                    field === 'Members->Members_DisplayNames_facet' ||
		                    field === 'Control Owner->Owner_DisplayName_facet' ||
		                    field === 'Person->Person_DisplayName_facet' ||
		                    field === 'Owner->OwnerDisplayName_facet' ||
		                    field === 'Owner Delegate->OwnerDelegateDisplayName_facet' ||
		                    field === 'Issuing Business Unit Head->IssuerBusinessUnitHead_facet' ||
		                    field === 'Plan Initiative Owner->OwnerDisplayName_facet' ||
		                    field === 'Plan Initiative Owner Delegate->OwnerDelegateDisplayName_facet' ||
		                    field === 'Person->AssessorDisplayName_facet' ||
		                    field === 'Recommendation Owner->OwnersIDs' ||
		                    field === 'Recommendation Owner Delegate->OwnerDelegateID' ||
							field === 'Supervisor->SupervisorID' ||
							field === 'Lead Auditor->LeadAuditorID'
	                    ) {
                            personFacet = true;
                        }

                        var controlStatusFacet = false;
                        if (field === 'Control Status->ControlAssessment_ControlStatus_TitleEn_facet') {
                            controlStatusFacet = true;
                        }

                        var booleanFacet = false;
                        if (field === 'Is Corporate->IsCorporate' ||
							field === 'With Action Plans->WithActionPlans' ||
							field === 'Handled by Project->HandledByProject' ||
							field === 'Is Closed->IsClosed') {
                            booleanFacet = true;
                        }

                        var mappedFieldValues =
                            _.chain(fieldValues)
                             .chunk(2) // From ["Value", Count, "Value", Count, ...] => [{value: "Value", count: Count }, ...]
                             .map(function (valueCountPair) {

                                 var value = valueCountPair[0];
                                 var count = valueCountPair[1];
                                 var isSelected = _.has(selectedFacets, fieldName) && selectedFacets[fieldName][value];

                                 var valueAlias = value;
                                 if (booleanFacet) {
                                     valueAlias = value === 'true' ? 'Yes' : 'No';
                                 }

                                 var val = {
                                     value: value,
                                     valueAlias: valueAlias,
                                     count: count,
                                     isSelected: isSelected,
                                     type: 'sf'
                                 };

                                 if (controlStatusFacet) {
                                     var valueMetadata = controlStatusFacetGroups[value.substring(value.indexOf("-") + 1)];
                                     val.ControlStatusCssLabel = valueMetadata.ControlStatusCssLabel;
                                     val.valueAlias = valueMetadata.ColumnValue;
                                 }

                                 return val
                             })
                             .value();

                        facetFields.push({
                            fieldAlias: fieldAlias,
                            fieldName: fieldName,
                            fieldValues: mappedFieldValues,
                            isPersonFacet: personFacet,
                            isPlainFacet: !personFacet && !controlStatusFacet,
                            isControlStatusFacet: controlStatusFacet,
                            isBooleanFacet: booleanFacet,
                            limit: $scope.initialMaxFacets,
                            fieldValueOp: fieldValueOp
                        });

                        return facetFields;
                    }, []);

                    var facetRanges = _.reduce(facetsToMap.facet_ranges, function (facetFields, fieldRange, field) {
                        var splittedField = field.split('->'); // ex: Control Area->ControlArea

                        var fieldDef = splittedField[0];
                        var splittedFieldDef = fieldDef.split('|'); // ex: Date|Month
                        var fieldAlias = splittedFieldDef[0];

                        var fieldName = fieldAlias;
                        if (splittedField.length > 1) fieldName = splittedField[1];

                        var fieldType = fieldAlias;
                        if (splittedFieldDef.length > 1) fieldType = splittedFieldDef[1];


                        var rangeConfig = rangesConfigs[fieldType];
                        if (!rangeConfig) return facetFields;

                        var valueTransformer = rangeConfig.valueTransformer;
                        var beforeValueTransformer = rangeConfig.beforeValueTransformer;
                        var afterValueTransformer = rangeConfig.afterValueTransformer;

                        var mappedFieldValues = [];

                        if (fieldRange.before > 0 && beforeValueTransformer) {
                            rangeValue = convertToRangeValue('*', fieldRange.start, rangeConfig);
                            isSelected = selectedFacets[fieldName] === rangeValue;
                            mappedFieldValues.push({
                                valueAlias: beforeValueTransformer(fieldRange.start),
                                count: fieldRange.before,
                                isSelected: isSelected,
                                type: 'sr',
                                rangeValue: rangeValue
                            });
                        }

                        // we need to enumerate ranges from flat array like ["range1_start", count, "range2_start", count, ...]
                        // in a way to be able group them as tuples like ["range1_start", count, "range2_start"], ["range2_start", count, "range3_start"], ...
                        // for last tuple we need to use beginning of last range and end the end limit from range query definition
                        for (var i = 0; i <= fieldRange.counts.length - 4; i = i + 2) {
                            var value = fieldRange.counts[i];
                            var count = fieldRange.counts[i + 1];
                            var nextValue = fieldRange.counts[i + 2];
                            var valueAlias = valueTransformer ? valueTransformer(value, nextValue) : value;
                            var rangeValue = convertToRangeValue(value, nextValue, rangeConfig);
                            var isSelected = selectedFacets[fieldName] === rangeValue;

                            mappedFieldValues.push({
                                valueAlias: valueAlias,
                                count: count,
                                isSelected: isSelected,
                                type: 'sr',
                                rangeValue: rangeValue
                            });
                        }

                        if (fieldRange.counts.length > 0) {
                            // add last range value (up to the end)
                            var lastRangeStart = _.nth(fieldRange.counts, -2);
                            var lastRangeCount = _.nth(fieldRange.counts, -1);
                            var lastRangeValue = convertToRangeValue(lastRangeStart, fieldRange.end, rangeConfig);
                            var lastIsSelected = selectedFacets[fieldName] === lastRangeValue;
                            mappedFieldValues.push({
                                valueAlias: valueTransformer ? valueTransformer(lastRangeStart, fieldRange.end) : value,
                                count: lastRangeCount,
                                isSelected: lastIsSelected,
                                type: 'sr',
                                rangeValue: lastRangeValue
                            });
                        }

                        if (fieldRange.after > 0 && afterValueTransformer) {
                            rangeValue = convertToRangeValue(fieldRange.end, '*', rangeConfig);
                            isSelected = selectedFacets[fieldName] === rangeValue;
                            mappedFieldValues.push({
                                valueAlias: afterValueTransformer(fieldRange.end),
                                count: fieldRange.after,
                                isSelected: isSelected,
                                type: 'sr',
                                rangeValue: rangeValue
                            });
                        }

                        var existingFacetField = _.chain(facetFields)
							.filter(function (facetField) {
							    return facetField.fieldAlias === fieldAlias;
							})
							.head()
							.value();

                        if (existingFacetField) {
                            existingFacetField.fieldValues = existingFacetField.fieldValues.concat(mappedFieldValues);
                        }
                        else {
                            facetFields.push({
                                fieldAlias: fieldAlias,
                                fieldName: fieldName,
                                fieldValues: mappedFieldValues
                            });
                        }

                        return facetFields;
                    }, []);

                    facets.facet_fields = facets.facet_fields.concat(facetRanges);

                    return facets;
                };

            }],
            link: function (scope, elem, attrs) {
                scope.$watch('searchSource.faceting', function (newValue) {
                    if (_.isUndefined(newValue)) return;

                    scope.facets = scope.mapFacets(newValue, scope.searchSource.faceting.selectedFields);
                }, true);
            }
        };
    }

})();